var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReportsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.1 8.24L20.73 2.9C20.15 2.32 19.38 2 18.57 2H5V30H27V10.41C27 9.59 26.68 8.82 26.1 8.24ZM25 28H7V4H17.42C17.95 4 18.38 4.43 18.38 4.96V10.6H24.04C24.57 10.6 25 11.03 25 11.56V28ZM19 18H9V16H19V18ZM23 22H9V20H23V22ZM18 26H9V24H18V26Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportsIcon);
export default __webpack_public_path__ + "static/media/Reports-icon.6a1847e4b531088975199ff82232c85b.svg";
export { ForwardRef as ReactComponent };